var React = require('react');

function CircleTick (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"10","cy":"10","r":"9.25","stroke":"currentColor","strokeWidth":"1.5","key":0}),React.createElement("path",{"d":"M4.83635 9.36397C5.22687 8.97344 5.86004 8.97344 6.25056 9.36397L9.7861 12.8995L8.37188 14.3137L4.83635 10.7782C4.44583 10.3877 4.44583 9.75449 4.83635 9.36397V9.36397Z","fill":"currentColor","key":1}),React.createElement("path",{"d":"M6.95752 12.8995L13.3215 6.53557C13.712 6.14505 14.3452 6.14505 14.7357 6.53557V6.53557C15.1262 6.9261 15.1262 7.55926 14.7357 7.94979L8.37173 14.3137L6.95752 12.8995Z","fill":"currentColor","key":2})]);
}

CircleTick.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = CircleTick;

CircleTick.default = CircleTick;
